import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/logo.jpeg';
const _withScopeId = n => (_pushScopeId("data-v-5ccce45a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "switch"
}, null, -1));
const _hoisted_2 = {
  class: "cont"
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = {
  class: "names"
};
const _hoisted_7 = {
  class: "desc"
};
const _hoisted_8 = {
  key: 0,
  class: "cares"
};
const _hoisted_9 = {
  key: 1,
  class: "cares"
};
const _hoisted_10 = {
  key: 2,
  class: "cares"
};
const _hoisted_11 = {
  class: "usercomment"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "head"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("span", null, "我")], -1));
const _hoisted_13 = {
  class: "comment"
};
import nav_header from '@/components/nav_header.vue';
import { self_comment } from '@/util/http';

import { ref, reactive } from 'vue';
export default {
  __name: 'comment',
  setup(__props) {
    const loading = ref(false);
    const finished = ref(false);
    let data = reactive({
      commentList: [],
      page: 1
    });
    const onLoad = () => {
      comment(data.page);
      data.page++;
    };
    let comment = page => {
      self_comment({
        page: page
      }).then(res => {
        let datas = res.data.data;
        if (res.message == "用户未登录或已过期") {
          showToast(res.message);
          return false;
        }
        if (datas.length == 0) {
          finished.value = true;
        } else {
          loading.value = false;
          data.commentList.push(...datas);
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "我的评论"
      }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_list, {
        loading: _unref(loading),
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => _isRef(loading) ? loading.value = $event : null),
        finished: _unref(finished),
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_unref(data).commentList.length == 0 ? (_openBlock(), _createBlock(_component_van_empty, {
          key: 0,
          style: {
            "margin-top": "100px"
          },
          description: "目前还没有评论哦"
        })) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(_unref(data).commentList, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "list",
            key: index
          }, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.create_time), 1)]), item.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, "快乐8论坛")) : _createCommentVNode("", true), item.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, "快乐8图库")) : _createCommentVNode("", true), item.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_10, "六合公式")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, _toDisplayString(item.content), 1)])]);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished"])])], 64);
    };
  }
};